import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import { redesignTheme } from '@rebeldotcom/components'
import Layout from '../components/layout'
import { SEO } from '../components/seo'
import './fragments'
import { tldReplace, getTemplatePanels } from '../utilities/templates'

const propTypes = {
  data: PropTypes.shape({
    pagesJson: PropTypes.shape({
      layoutProps: PropTypes.shape({
        removeNavigation: PropTypes.bool,
        showNewsletterSignup: PropTypes.bool,
      }),
      panels: PropTypes.arrayOf(PropTypes.shape({})),
      reseller: PropTypes.string,
      seo: PropTypes.shape({
        description: PropTypes.string,
        title: PropTypes.string,
      }).isRequired,
      slug: PropTypes.string.isRequired,
      supportLinkTitle: PropTypes.string.isRequired,
      variant: PropTypes.oneOf(['old', 'new']),
    }),
  }).isRequired,
  pageContext: PropTypes.shape({ item: PropTypes.object }).isRequired,
}

const TldPage = ({ data, pageContext }) => {
  const { item: tld } = pageContext
  const {
    panels,
    seo: pageSEO,
    slug,
    layoutProps,
    variant,
    supportLinkTitle,
  } = data.pagesJson

  const mainContent = getTemplatePanels({
    panels,
    dictionary: tld,
    supportLinkTitle,
    slug,
    variant,
  })

  const { title, description, imageUrl } = pageSEO
  const showNewsletterSignup = layoutProps?.showNewsletterSignup
  const hasNavigation = layoutProps?.removeNavigation

  return (
    <Layout
      hasNavigation={!hasNavigation}
      location={slug}
      showNewsletterSignup={showNewsletterSignup}
    >
      <SEO
        description={tldReplace(description, tld)}
        imageUrl={imageUrl}
        location={slug}
        title={tldReplace(title, tld)}
      />
      {mainContent}
    </Layout>
  )
}

export const query = graphql`
  query ($slug: String!, $reseller: String, $templateType: String) {
    pagesJson(
      slug: { eq: $slug }
      reseller: { eq: $reseller }
      templateType: { eq: $templateType }
    ) {
      slug
      seo {
        title
        description
        imageUrl
      }
      dataSrc
      reseller
      templateType
      variant
      supportLinkTitle
      panels {
        type
        ...HeroPanel
        ...TrustPilotPanel
        ...OurTeamPanel
        ...FAQPanel
        ...ProductDetailsPanel
        ...CTAPanel
        ...CTAPairPanel
        ...NewsletterPanel
        ...SpreadPanel
        ...FeatureComparisonPanel
        ...InfoCollector
        ...TwinPanel
        ...SimpleSearchPanel
        ...WordPressThemesPanel
        ...TldSearchPanel
      }
    }
  }
`
TldPage.propTypes = propTypes

export default TldPage
